import { ContentChild, Directive, Input, TemplateRef } from '@angular/core';
import { TableCellDirective } from './table-cell.directive';
import { TableHeaderDirective } from './table-header.directive';

@Directive({
  selector: '[uiTableColumn]',
})
export class TableColumnDirective {
  @Input()
  public name!: string;

  @Input()
  public justifyContent: 'start' | 'center' | 'end' = 'start';

  @ContentChild(TableHeaderDirective, { read: TemplateRef })
  public headerRef!: TemplateRef<unknown>;

  @ContentChild(TableCellDirective, { read: TemplateRef })
  public cellRef!: TemplateRef<unknown>;
}
